<template>
    <dx-popup
      :visible="localVisible"
      title="Add Category"
      :show-title="true"
      width="600px"
      height="auto"
      @update:visible="updateVisible"
    >
      <DxForm ref="newCategory" validation-group="categoryForm" :form-data="category">
        <DxSimpleItem
          dataField="name"
          :editorOptions="{
            placeholder: 'Category Name',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[
            { type: 'required', message: 'Name is required!' }
            ]"
          
        />
        <DxSimpleItem
          dataField="description"
          :editorOptions="{
            placeholder: 'Category Description',
            stylingMode: 'underlined',
            elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px; margin-bottom: 10px;' }
          }"
          :label="{ visible: false }"
          :validationRules="[{ type: 'required', message: 'Description is required!' }]"
        />
 
        <DxButtonItem
          :buttonOptions="{
            text: 'Cancel',
            type: 'normal',
            onClick: cancel,
            width: '100px'
          }"
        />
        <DxButtonItem
          :buttonOptions="{
            text: 'Save',
            type: 'success',
            onClick: saveCategory,
            width: '100px'
          }"
        />
      </DxForm>
    </dx-popup>
  </template>
  
  <script>
  import { DxPopup } from 'devextreme-vue/popup';
  import { DxForm, DxSimpleItem, DxButtonItem } from 'devextreme-vue/form';
  import validationEngine from 'devextreme/ui/validation_engine';
  import notify from 'devextreme/ui/notify';
  
  export default {
    components: {
      DxPopup,
      DxForm,
      DxSimpleItem,
      DxButtonItem
    },
    props: {
      visible: {
        type: Boolean,
        required: true
      }
    },
    watch: {
      visible(newVal) {
        this.localVisible = newVal;
      }
    },
    data() {
      return {
        localVisible: this.visible,
        category: {
          name: '',
          description: '',
          created: null // Add this line
        }
      };
    },
    methods: {
      updateVisible(newVal) {
        this.$emit('update:visible', newVal);
      },
      saveCategory() {
      // Validate the form before saving
      const result = validationEngine.validateGroup('categoryForm');

      if (result.isValid) {
      // Set the created field to the current date and time
      this.category.created = this.formatDate(new Date());

      // Logic to save the category
      fetch(`${process.env.VUE_APP_API_URL}/category/create.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
       },
        body: JSON.stringify(this.category)
       })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
       }
        return response.json();
      })
      .then(data => {
      console.log('Category saved:', data);
      this.$emit('save', this.category);
      this.updateVisible(false);

      // Notify the user that the category has been saved
      notify(`Category saved with ID: ${data.id}`, 'success', 3000);
      this.resetForm();
      })
      .catch(error => {
        console.error('Error saving category:', error);
      });
    }
    },
      cancel() {
        this.updateVisible(false);
      },

      formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      const hours = ('0' + d.getHours()).slice(-2);
      const minutes = ('0' + d.getMinutes()).slice(-2);
      const seconds = ('0' + d.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
     },
     resetForm() {
        this.category = {
          name: '',
          description: '',
          created: null
        };
      }
    }
  };
  </script>
  
  <style scoped>
  .form-popup-buttons-container {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
  /* Add your styles here */
  </style>